import { camelToSnakeCase, trim } from "@/helpers/string.helpers"
import { PayloadHandler, type Values } from "@/organisms/Form"

export class ScopeSpecificResourcesHandler extends PayloadHandler {
  public handle(request: Values) {
    const { resources, specific_resources, ...rest } = request

    if (resources === "all_resources")
      return super.handle({
        scope: {
          repository_name: null,
          organization_name: null,
          github_topics: null
        },
        ...rest
      })

    const scope = Array.isArray(specific_resources) ? specific_resources : []

    return {
      scope: scope.reduce(
        (acc, { type, value }) => {
          if (!type || !value) return acc

          const nextValue = trim(value)

          acc[camelToSnakeCase(type)] = Array.isArray(nextValue)
            ? nextValue.join(",")
            : nextValue

          return acc
        },
        {} as Record<string, string>
      ),
      ...rest
    }
  }
}
